import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/regions'

class RegionDataService extends RestApiDataService {

}

export default new RegionDataService(BASE_ENTITY_URL)
